import { allEntries } from "./parser";
import type { ScriptDocument } from "./types";

export const BACKUP_FORMAT = "linebyline-script-backup";
export const BACKUP_VERSION = 1;

export interface ScriptBackup {
  format: typeof BACKUP_FORMAT;
  version: typeof BACKUP_VERSION;
  exportedAt: string;
  script: ScriptDocument;
}

export function safeExportName(title: string): string {
  return title.replace(/[^a-z0-9-_]+/gi, "-").replace(/^-+|-+$/g, "").toLowerCase() || "script";
}

export function exportText(document: ScriptDocument): string {
  return document.sourceText;
}

export function exportJson(document: ScriptDocument): string {
  const backup: ScriptBackup = {
    format: BACKUP_FORMAT,
    version: BACKUP_VERSION,
    exportedAt: new Date().toISOString(),
    script: document,
  };
  return JSON.stringify(backup, null, 2);
}

export function exportMarkdown(document: ScriptDocument): string {
  const tags = document.tags.length ? `\n\n**Tags:** ${document.tags.join(", ")}` : "";
  const script = allEntries(document).map((item) => {
    if (item.kind === "dialogue") return `**${item.speakerLabel ?? "Reader"}:** ${item.text}`;
    if (item.kind === "heading") return `## ${item.text}`;
    return `_${item.text}_`;
  }).join("\n\n");
  const notes = document.notes ? `\n\n## Rehearsal notes\n\n${document.notes}` : "";
  return `# ${document.title}${tags}\n\n${script}${notes}`;
}
